import React, { useEffect, useState } from "react";
import "../styles/Particles.css";

const Particles = ({ darkMode }) => {
  const [particles, setParticles] = useState([]);

  useEffect(() => {
    // Generate 25 random particles
    const numParticles = 25;
    const generatedParticles = Array.from({ length: numParticles }, (_, i) => ({
      id: i,
      size: Math.random() * 15 + 10, // Random size between 10px - 25px
      top: Math.random() * 100 + "%", // Random position
      left: Math.random() * 100 + "%",
      animationDuration: Math.random() * 20 + 15 + "s", // Random duration 15-35s
    }));
    
    setParticles(generatedParticles);
  }, []);

  return (
    <div className="mainparticles">
      {particles.map((particle) => (
        <div
          key={particle.id}
          className="edparticle"
          style={{
            width: particle.size,
            height: particle.size,
            top: particle.top,
            left: particle.left,
            animationDuration: particle.animationDuration,
            background: darkMode ? "#ff758c" : "#ffe6e9", // Different colors for themes
          }}
        ></div>
      ))}
    </div>
  );
};

export default Particles;
